<!-- Hero Section starts here -->

<div class="ew-hero">
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>
  <div class="spacer"></div>

  <h1 class="hro-head">Tired of Learning ? <span>Start Earning!</span></h1>

  <h2 class="course-head">AI & Data Tech Launhpad: 8-Weeks AI & Data Science Program</h2>

  <h4>
    Welcome to the <Strong> 8-Week Industry-Ready Program </Strong>, where we
    bridge the gap between classroom knowledge and real-world careers. This
    isn't just another course; it's a career accelerator designed with direct
    input from industry experts to equip you with the skills employers are
    actively seeking. Forget theoretical fluff – we focus on what gets you
    hired!
  </h4>

  <button class="cta-1" style="z-index: 2;" (click)="openCta()">Enroll Now</button>

  <div class="spacer"></div>
  <div class="spacer"></div>
</div>

<!-- hero section ends here -->

<img class="hex-stroke" src="assets/images/stroke1.png" alt="" />

<!-- EXPLORER SECTION STARTS HERE -->

<div class="ew-explore">
  <h1>Hello! Explorer</h1>
  <h3>What You Want to <span>Learn?</span></h3>

  <div class="ew-explore-cards">
    <div class="ew-explore-card">
      <img src="assets/images/cd1.png" alt="" />

      <button class="cta-1" (click)="openCta()">Enroll Now</button>
    </div>

    <div class="ew-explore-card">
      <img src="assets/images/cd2.png" alt="" />

      <button class="cta-1" (click)="openCta()">Enroll Now</button>
    </div>

    <div class="ew-explore-card">
      <img src="assets/images/cd3.png" alt="" />

      <button class="cta-1" (click)="openCta()">Enroll Now</button>
    </div>
  </div>
</div>

<!-- WHAT MAKES US DIFFERENT -->

<div class="wmd-container">
  <h1>What Makes Us Different?</h1>

  <div class="wmd-cards">
    <!-- one  -->
    <div class="wmd-card">
      <img src="assets/images/wmd1.png" alt="" />

      <h4 class="">Learn By Doing</h4>

      <p>
        Build real-world projects that showcase your abilities, validated
        through weekly project defenses (Vivas).
      </p>
    </div>

    <!-- two -->
    <div class="wmd-card">
      <img src="assets/images/wmd2.png" alt="" />

      <h4 class="">Industry-Aligned Skills</h4>

      <p>
        Master high-demand technologies like AngularJS, Data Science, DevOps,
        Generative AI, and Prompt Engineering.
      </p>
    </div>

    <!-- three -->
    <div class="wmd-card">
      <img src="assets/images/wmd3.png" alt="" />

      <h4 class="">Hands-On Immersion</h4>

      <p>
        Every module is packed with practical exercises, daily tasks, and
        project-based learning.
      </p>
    </div>

    <!-- four -->
    <div class="wmd-card">
      <img src="assets/images/wmd4.png" alt="" />

      <h4 class="">Integrated Soft Skills</h4>

      <p>
        Develop crucial professional skills like communication, teamwork,
        presentation, and interview techniques alongside your technical
        training.
      </p>
    </div>

    <!-- five -->
    <div class="wmd-card">
      <img src="assets/images/wmd5.png" alt="" />

      <h4 class="">Comprehensive Assessment</h4>

      <p>
        Your learning is solidified through weekly MCQs, hands-on project
        submissions, and final panel reviews.
      </p>
    </div>

    <!-- six -->
    <div class="wmd-card">
      <img src="assets/images/wmd6.png" alt="" />

      <h4 class="">Placement Support</h4>

      <p>
        Every module is packed with practical exercises, daily tasks, and
        project-based learning.
      </p>
    </div>
  </div>
</div>


<!-- Programs -->

<div class="prog-container">
  
  <p class="prog-cont-head">
    Your Journey to Tech Mastery: <span>Our Signature Programs</span> 
  </p>

  <img class="hex-stroke2" src="assets/images/stroke1.png" alt="" />


  <div class="progs-cards">

    <div class="progs-card">

      <img src="assets/images/pgrm1.jpg" alt="">

     

      <p class="pc-p">
        1-on-1 Intensive
      </p>

       <p class="pc-p2"> Personalized mentorship, flexible scheduling, and accelerated learning.</p>

    </div>

     <div class="progs-card">

      <img src="assets/images/pgrm2.jpg" alt="">

     

      <p class="pc-p">
        Classroom Immersion
      </p>

       <p class="pc-p2">Collaborative learning in a small batch (max 10 students), fostering peer interaction and a supportive environment.</p>

    </div>

  </div>

</div>


<!-- Program Details -->

<div class="section-breakdown">

  <div class="spacer"></div>

  <div class="accordion">
    <div
      class="accordion-item"
      *ngFor="let week of weeks; let i = index"
      [class.open]="openIndex === i">

      <div class="accordion-header" (click)="toggleAccordion(i)">
        <span [innerHTML]="week.title"></span>
        <svg class="accordion-icon" width="32" height="32">
          <polyline points="10,14 16,20 22,14" fill="none" stroke="#222" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <div
        class="accordion-content"
        [style.maxHeight]="openIndex === i ? '900px' : null"
        [style.opacity]="openIndex === i ? '1' : null"
        [@accordion]="openIndex === i ? 'open' : 'closed'">

        <div [innerHTML]="week.content"></div>
      </div>
    </div>
  </div>
</div>


<!-- PROGRAM DETAILS END HERE -->


<!-- Common module -->

<div class="cm-cont">

  <h1>Common Modules (All 8-Week Internship Tracks)</h1>

  <div class="spacer"></div>
  <div class="cm-card">

    <div class="cm-card-right">

      <p class="cmc-h">DevOps & Agile Catalyst (Weeks 5-6/Common): </p>

      <p class="cmc-p">
        Master essential tools and methodologies like Git, CI/CD, and Scrum to streamline software development and deployment. (Integrated into Data Science and GenAI as part of practical applications).
      </p>


    </div>

    <div class="cm-card-left">
<img src="assets/images/dev-ops.webp" alt="">
    </div>
    

  </div>

  <div class="cm-card">

    <div class="cm-card-right">

      <p class="cmc-h">Capstone Zenith (Weeks 7-8/Common):  </p>

      <p class="cmc-p">
        Collaborate on a team-based real-world problem-solving project that culminates in a grand finale. This is where all your skills converge! 
      </p>


    </div>

    <div class="cm-card-left">
<img src="assets/images/cmc-2.png" alt="">
    </div>
    

  </div>

  <div class="spacer"></div>


</div>

<!-- WHO IS THE PROGRAM FOR -->


<div class="wtp-cont">

  <h1>Who Is This Program For?</h1>

  <div class="spacer"></div>

  <div class="ptm-container">
    <div class="ptm-content">
      <p>
        <span class="highlight">Students: </span> Elevate your academic degree with in-demand practical skills and impressive projects.
      </p>

      <p>
        <span class="highlight">Career Switchers:</span> Make a confident transition into the tech industry with structured training and tangible results.
      </p>

      <p>
        <span class="highlight">Job Seekers: </span> Stand out from the crowd with a robust portfolio of projects and a clear path to employment.
      </p>
    </div>
    <div class="ptm-image">
      <img src="assets/images/wtp-img.jpg" alt="Parent-Teacher Meeting">
    </div>
  </div>

  <div class="spacer"></div>

</div>

<div class="end-cont">

  <p class="end-head">Your Path to Employment: Our Commitment</p>

  <button class="cta-1" (click)="openCta()">
    Enroll Now
  </button>

</div>





